import { render, staticRenderFns } from "./lightup.vue?vue&type=template&id=f0f17944&scoped=true&"
import script from "./lightup.vue?vue&type=script&lang=js&"
export * from "./lightup.vue?vue&type=script&lang=js&"
import style0 from "./lightup.vue?vue&type=style&index=0&id=f0f17944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f17944",
  null
  
)

export default component.exports